import { render, staticRenderFns } from "./page-boards.vue?vue&type=template&id=130003fc&"
import script from "./page-boards.vue?vue&type=script&lang=js&"
export * from "./page-boards.vue?vue&type=script&lang=js&"
import style0 from "./page-boards.vue?vue&type=style&index=0&id=130003fc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports